function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#headshot-placeholder_svg__headshot-placeholder_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#headshot-placeholder_svg__headshot-placeholder_svg__b)",
  d: "M0 0h506.616v521.195H0z"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#headshot-placeholder_svg__headshot-placeholder_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F0F0F0",
  d: "M41.914 43.12h422.787v434.954H41.914z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DEDEDE",
  d: "M41.914 43.12h422.788v434.954H41.914z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M188.599 276.567a91.517 91.517 0 010-129.418 91.517 91.517 0 01129.418 0 91.513 91.513 0 01-129.418 129.418zm-41.178 95.62a149.748 149.748 0 00-43.86 105.887h299.493a149.747 149.747 0 00-255.633-105.887z",
  fill: "#000"
})));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "headshot-placeholder_svg__headshot-placeholder_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h506.616v521.195H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "headshot-placeholder_svg__headshot-placeholder_svg__c"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(41.914 43.12)",
  d: "M0 0h422.787v434.954H0z"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "headshot-placeholder_svg__headshot-placeholder_svg__b",
  x1: 65.749,
  y1: 40.092,
  x2: 545.982,
  y2: 70.36,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#891291"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE3876"
})));

function SvgHeadshotPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 507,
    height: 522,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTA3IiBoZWlnaHQ9IjUyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8ZyBjbGlwLXBhdGg9InVybCgjYSkiPgogICAgPHBhdGggZmlsbD0idXJsKCNiKSIgZD0iTTAgMGg1MDYuNjE2djUyMS4xOTVIMHoiLz4KICAgIDxnIGNsaXAtcGF0aD0idXJsKCNjKSI+CiAgICAgIDxwYXRoIGZpbGw9IiNGMEYwRjAiIGQ9Ik00MS45MTQgNDMuMTIwMWg0MjIuNzg3djQzNC45NTRINDEuOTE0eiIvPgogICAgICA8cGF0aCBmaWxsPSIjREVERURFIiBkPSJNNDEuOTE0NSA0My4xMjAxaDQyMi43ODh2NDM0Ljk1NEg0MS45MTQ1eiIvPgogICAgICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE4OC41OTkgMjc2LjU2N2MtMTcuMTYxLTE3LjE2Mi0yNi44MDMtNDAuNDM5LTI2LjgwMy02NC43MDkgMC0yNC4yNyA5LjY0Mi00Ny41NDcgMjYuODAzLTY0LjcwOSAxNy4xNjItMTcuMTYxIDQwLjQzOS0yNi44MDMgNjQuNzA5LTI2LjgwMyAyNC4yNzEgMCA0Ny41NDcgOS42NDIgNjQuNzA5IDI2LjgwMyAxNy4xNjIgMTcuMTYyIDI2LjgwMyA0MC40MzkgMjYuODAzIDY0LjcwOSAwIDI0LjI3LTkuNjQxIDQ3LjU0Ny0yNi44MDMgNjQuNzA5LTE3LjE2MiAxNy4xNjEtNDAuNDM4IDI2LjgwMy02NC43MDkgMjYuODAzLTI0LjI3IDAtNDcuNTQ3LTkuNjQyLTY0LjcwOS0yNi44MDNabS00MS4xNzggOTUuNjJjLTI4LjA4MyAyOC4wODMtNDMuODYgNjYuMTcyLTQzLjg2IDEwNS44ODdoMjk5LjQ5M2MwLTM5LjcxNS0xNS43NzYtNzcuODA0LTQzLjg1OS0xMDUuODg3LTI4LjA4My0yOC4wODMtNjYuMTcyLTQzLjg1OS0xMDUuODg3LTQzLjg1OXMtNzcuODA0IDE1Ljc3Ni0xMDUuODg3IDQzLjg1OVoiIGZpbGw9IiMwMDAiLz4KICAgIDwvZz4KICA8L2c+CiAgPGRlZnM+CiAgICA8Y2xpcFBhdGggaWQ9ImEiPgogICAgICA8cGF0aCBmaWxsPSIjZmZmIiBkPSJNMCAwaDUwNi42MTZ2NTIxLjE5NUgweiIvPgogICAgPC9jbGlwUGF0aD4KICAgIDxjbGlwUGF0aCBpZD0iYyI+CiAgICAgIDxwYXRoIGZpbGw9IiNmZmYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQxLjkxNCA0My4xMjAxKSIgZD0iTTAgMGg0MjIuNzg3djQzNC45NTRIMHoiLz4KICAgIDwvY2xpcFBhdGg+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImIiIHgxPSI2NS43NDk0IiB5MT0iNDAuMDkyMiIgeDI9IjU0NS45ODIiIHkyPSI3MC4zNjAyIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiM4OTEyOTEiLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjRkUzODc2Ii8+CiAgICA8L2xpbmVhckdyYWRpZW50PgogIDwvZGVmcz4KPC9zdmc+Cg==";
export { SvgHeadshotPlaceholder as ReactComponent };